import { Navigation } from "@/components/public/layout/Navigation"
import Documents from "@/components/public/Documents"
import { Footer } from "@/components/public/layout/Footer"
import FloatingMenu from "@/components/public/FloatingMenu"

export default function DocumentPage() {
    return (
        <div className="min-h-screen bg-background dark:bg-gray-900">
            <Navigation />
            <Documents />
            <Footer />
            <FloatingMenu />
        </div>
    )
}
